<template>
  <div v-if="!pending" class="tailwind" style="position: relative; z-index: 1">
    <HotelListAutomated
      @open-availability-calendar="openAvailCalendar"
      @open-omebt-modal="openOmebtModal"
      @open-redirect-lang-modal="openRedirectLangModal"
      :cardConfig="cardConfig"
      :filters="filters"
      :layoutConfig="layoutConfig"
    />
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { HotelListAutomated } from '@common/lib-vue-common'
import { startUpLabels } from './composables/useLabels.js'

defineProps({
  cardConfig: Object,
  filters: Object,
  layoutConfig: Object
})

const pending = ref(true)

onMounted(async () => {
  await startUpLabels()
  pending.value = false
})

const openAvailCalendar = ({ hotelCode, hotelName, openingDate, minNightsPerStay }) => {
  window.selectedHotel = {
    name: hotelName,
    code: hotelCode,
    openingDate,
    minNightsPerStay
  }
  window.searchBarVue.$emit('open-searchbar-modal')
}

const openOmebtModal = ({ hotelCode, hotelName }) => {
  window.HotelListAutomated.handleOmbtModalOpen(hotelCode, hotelName)
}

const openRedirectLangModal = ({ url }) => {
  window.Utils.showRedirectLangModal(url)
}
</script>
